import { z } from "zod";
import { facturaBaseSchema, emisorBaseSchema } from "./common.schema";

export const resumenFEXSchema = z
  .object({
    totalGravada: z.number().default(0),
    descuento: z.number().default(0),
    porcentajeDescuento: z.number().default(0),
    totalDescu: z.number().default(0),
    seguro: z.number().default(0),
    flete: z.number().default(0),
    montoTotalOperacion: z.number().default(0),
    totalNoGravado: z.number().default(0),
    totalPagar: z.number().default(0),
    totalLetras: z.string().default(""),
    condicionOperacion: z.number().default(2), // 1 contado, 2 credito, 3 otros
    pagos: z
      .array(
        z.object({
          codigo: z.string(),
          montoPago: z.number(),
          referencia: z.string().nullable(),
          plazo: z.string().nullable(),
          periodo: z.number().nullable(),
        })
      )
      .nullable()
      .default(null),
    codIncoterms: z.union([z.string(), z.null()]),
    descIncoterms: z.union([z.string().min(3).max(150), z.null()]),
    numPagoElectronico: z.string().nullable().default(null),
    observaciones: z.union([z.string().max(500), z.null()]),
  })
  .strip();

export const emisorFEXSchema = emisorBaseSchema
  .omit({ codEstableMH: true, codPuntoVentaMH: true, codEstable: true, codPuntoVenta: true })
  .strip();

export const facturaFEXchema = facturaBaseSchema
  .omit({ extension: true, documentoRelacionado: true })
  .extend({
    resumen: resumenFEXSchema,
    otrosDocumentos: z.any().nullable(),
    emisor: emisorBaseSchema
      .extend({
        tipoItemExpor: z.literal(2),
        recintoFiscal: z.null(),
        regimen: z.null(),
      })
      .strip(),
  })

  .strip();
